<template>
  <Padding :padding="padding">
    <ButtonRow
      v-if="buttonRow"
      v-bind="buttonRow"
    >
    </ButtonRow>
  </Padding>
</template>

<script lang="ts" setup>
import ButtonRow from './ButtonRow.vue';
import Padding from '../Padding/Padding.vue';
import type { PortableTextButtonRow } from '~/sanity/types';
defineProps<PortableTextButtonRow>();
</script>

<style></style>
